/** */
export const PAGE_TITLE = 'page title to set';

/** */
export const setPageTitle = (payload) => ({
  type: PAGE_TITLE,
  payload
});
